export const THEMES = [
  { id: 'light', name: 'Светлая' },
  { id: 'second-light', name: 'Светлая' },
  { id: 'dark', name: 'Тёмная' },
]; 